import styled from 'styled-components';

export const getBorderStyle = (
  disabled?: boolean,
  checked?: boolean,
  customBorder?: string
) => {
  if (disabled) {
    return '2px solid rgba(0, 0, 0, 0.13)';
  } else if (checked) {
    return '2px solid #009ACE';
  } else {
    return `2px solid ${customBorder ? customBorder : 'rgba(0, 0, 0, 0.93)'}`;
  }
};

export const OuterCircle = styled.div<{
  checked?: boolean;
  disabled?: boolean;
}>`
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  border: ${({ disabled, checked }) => getBorderStyle(disabled, checked)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  transition: all 0.1s linear;
`;

export const InnerCircle = styled.div<{
  checked?: boolean;
  disabled?: boolean;
}>`
  width: ${({ checked }) => (checked ? '10px' : '0px')};
  height: ${({ checked }) => (checked ? '10px' : '0px')};
  border-radius: 50%;
  background-color: ${({ disabled }) =>
    disabled ? 'rgba(0, 0, 0, 0.125)' : '#009ace'};
  transition: all 0.1s linear;
  &:disabled {
    color: rgba(0, 0, 0, 0.125);
  }
`;

export const Label = styled.label<{ disabled?: boolean }>`
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;
  align-items: center;
  width: fit-content;

  color: ${({ disabled }) => (disabled ? '#00000039' : 'rgba(0, 0, 0, 0.93)')};
  padding-right: 8px;
`;

export const Input = styled.input<{
  disabled?: boolean;
  marginTop?: string;
  marginRight?: string;
  marginBottom?: string;
  marginLeft?: string;
}>`
  min-width: 20px;
  height: 20px;
  color: black;

  accent-color: #009ace;

  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : '5px')};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0px')};
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '10px')};

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;
